import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const argocd = defineConnector({
  identifier: "argocd",
  name: "Argo CD",
  tagLine: "GitOps continuous delivery for Kubernetes",
  logo,
  protocol: "http",
  tags: ["engineering"],
  auth: (app) => bearerAuth(app.secret.apiToken),
  steps: [
    {
      title: "Get your Argo CD API token",
      items: [
        {
          kind: "markdown",
          content:
            "In Argo CD, go to **Settings > Accounts**, select your account, and generate a new token. Alternatively, use the CLI: `argocd account generate-token`.",
        },
      ],
    },
    {
      title: "Enter your Argo CD details",
      items: [
        {
          kind: "baseUrl",
          label: "Argo CD server URL",
          required: true,
          placeholder: "https://argocd.example.com",
          target: { kind: "configuration", field: "instanceUrl" },
          helperText: "The base URL of your Argo CD server.",
        },
        {
          kind: "input",
          label: "API token",
          required: true,
          target: { kind: "secrets", field: "apiToken" },
        },
      ],
    },
  ],
  defaultUrlPattern: ({ instanceUrl }) => domainToRegex(instanceUrl),
  connectionTest: {
    protocol: "http",
    request: ({ instanceUrl }) => `${instanceUrl}/api/v1/session/userinfo`,
  },
});
